/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { Form } from '@ant-design/compatible';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
import { DatePicker, Input, Select, Col, Radio } from 'antd';
import { isEmpty, isUndefined } from 'underscore';
import Sticky from 'react-sticky-el';
import '@rc-component/color-picker/assets/index.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import * as dashboardActions from '../../../../core/dashboard/dashboardActions';
import * as smartWidgetActions from '../../../../core/smartWidget/smartWidgetActions';
import ChartMultiDropDown from '../../ChartComponents/ChartMultiDropDown';
import PieChartWithCustomizedLabel from '../../ChartComponents/PieChartWithCustomizedLabel';
import ColorRule from '../ColorRule';
import { Calendar } from "@carbon/icons-react";

const { Option } = Select;
const FormItem = Form.Item;

class PieChartForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }

    onColorRadioChange = (e) => {
        this.setState({ colorOption: e.target.value });
    };

    onInputUpdates = () => {
        const { getChartDataFromInput } = this.props;

        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            getChartDataFromInput();
        }, 700);
    }

    getDataSet = () => {
        const { form, getChartDataFromInput, data } = this.props;
        const { getFieldDecorator, getFieldValue } = form;
        const fieldCounter = getFieldValue('input_dataList');

        return fieldCounter.map((k, num) => {

            let icon_hover_text = '';
            let colorRuleData = [];
            let color_type = 'fixed';

            if(!isUndefined(data) && !isEmpty(data[k])) {
                icon_hover_text = data[k].icon_hover_text;
                colorRuleData = (data[k]?.color_type == 'smart-rule') ? data[k].rules : data[k].color;
                color_type = data[k]['color_type'];
            }

            return <div key={k}>
                <div className="ant-col ant-form-item ant-form-item-label">
                    <label title={`Data ${num + 1}`}>Data {num + 1}</label>
                </div>

                <div className="data-box">
                    <FormItem label="Icon Hover Text">
                        {getFieldDecorator(`input_data[${k}][icon_hover_text]`, {
                            rules: [
                                {
                                    required: true,
                                    message: 'Please enter label text',
                                },
                            ],
                            initialValue: icon_hover_text
                        })(
                            <Input
                                placeholder="Enter Label"
                                onChange={() => this.onInputUpdates()} />,
                        )}
                    </FormItem>
                    <br/>

                    <ColorRule
                        onChange={() => getChartDataFromInput()}
                        form={form}
                        mode={color_type}
                        data={colorRuleData}
                        name={`input_data[${k}]`}/>
                </div>
                <br/>
            </div>
        });
    }

    getPreviewData = () => {

        const random = () => {
            const min = 1;
            const max = 100;
            const rand = min + (Math.random() * (max - min));
            return Math.floor(rand);
        };

        const { form } = this.props;
        const { getFieldValue } = form;

        const fieldCounter = getFieldValue('input_dataList');

        return fieldCounter.map((k) => ({
            name: form.getFieldValue(`input_data[${k}][icon_hover_text]`),
            value: random(),
            // active: false,
        }));
    }

    getCustomPreviewData = () => {

        const random = () => {
            const min = 1;
            const max = 100;
            const rand = min + (Math.random() * (max - min));
            return Math.floor(rand);
        };

        const { form } = this.props;
        const { getFieldValue } = form;

        const fieldCounter = getFieldValue('input_dataList');

        return fieldCounter.map((k) => ({
            name: form.getFieldValue(`input_data[${k}][icon_hover_text]`),
            value: random(),
            // active: false,
        }));
    }

    render() {
        const { form, saveDatatypeValues, getChartDataFromInput, division, driver, asset, setTimeframe, smartWidget, data, telematicsRetentionDays } = this.props;
        const { getFieldDecorator } = form;

        const dataSet = this.getDataSet();
        let preview = (
            <div className="smart-widget-preview">
                <h2>Widget Preview</h2>
                <FormItem className="widget-preview-date">
                    {getFieldDecorator('date', {
                        initialValue: dayjs(),
                        rules: [
                        ],
                    })(
                        <DatePicker
                            onChange={() => getChartDataFromInput()}
                            format="DD/MM/YYYY" 
                            minDate={dayjs().subtract(telematicsRetentionDays, 'days')}
                            allowClear={false}
                            suffixIcon={<Calendar />}
                            maxDate={dayjs()}
                        />,
                    )}

                </FormItem>
                <br />

                <PieChartWithCustomizedLabel
                    heightRatio={2}
                    timeframe={smartWidget?.presetWidget?.timeframe || 'hourly'}
                    onTimeframeChange={(timeframe) => setTimeframe(timeframe)}
                    rightMenuItems={[]}
                    tooltipText={smartWidget?.presetWidget?.name || 'This is tooltip text'}
                    data={smartWidget.chartData}
                    dataKey="value"
                    showLabelAndValue={form.getFieldValue('show_label_and_value')}
                    fill="#FDCE7D"
                    onAllOptionChange={(optionsData) => { saveDatatypeValues(optionsData); getChartDataFromInput(); }}
                    divisions={[...division.divisionOptions]}
                    drivers={[...driver.driverList]}
                    assets={[...asset.options]} />
                <br />
            </div>
        );

        const isSticky = window.innerWidth > 767;
        if(isSticky){
            preview = <Sticky>{ preview }</Sticky>;
        }

        let show_label_and_value = 'both';
        let main_label_text = '';
        if(typeof data !== 'undefined') {
            show_label_and_value = data[0].show_label_and_value;
            main_label_text = data[0].main_label_text;
        }

        return (
            <>
                <Col className="gutter-row first-col" xs={24} sm={24} md={12} lg={12} xl={12}>
                    <div className="input-data-col">
                        <FormItem label="Title">
                            {getFieldDecorator('input_data[0][main_label_text]', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Please enter title',
                                    },
                                ],
                                initialValue: main_label_text,
                            })(
                                <Input
                                    placeholder="Enter Title"
                                    onChange={() => this.onInputUpdates()} />,
                            )}
                        </FormItem>
                        <br />

                        <FormItem className="icon-position-checkbox" label="Show label and value">
                            {getFieldDecorator('input_data[0][show_label_and_value]', {
                                initialValue: show_label_and_value,
                                rules: [
                                ],
                            })(
                                <Radio.Group onChange={() => getChartDataFromInput()}>
                                    <Radio value="both">Both Always</Radio>
                                    <Radio value="label">Label Only</Radio>
                                    <Radio value="data">Data Only</Radio>
                                    <Radio value="hover">Hide and show on hover</Radio>
                                </Radio.Group>,
                            )}
                        </FormItem>
                        <br />

                        { dataSet }

                        <br />

                        <p className="default-data-view">Default data view</p>

                        <ChartMultiDropDown
                            onDataChange={(optionsData) => saveDatatypeValues(optionsData)}
                            divisions={[...division.divisionOptions]}
                            drivers={[...driver.driverList]}
                            assets={[...asset.options]} />
                    </div>
                </Col>
                <Col className="smart-widget-preview-row gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
                    { preview }
                </Col>
            </>
        );
    }
}

PieChartForm.defaultProps = {
    inputData: [],
    saveDatatypeValues: () => {},
    getChartDataFromInput: () => {},
    setTimeframe: () => {},
};

PieChartForm.propTypes = {
    actions: PropTypes.object.isRequired,
    smartWidget: PropTypes.object.isRequired,
    inputData: PropTypes.array,
    saveDatatypeValues: PropTypes.func,
    getChartDataFromInput: PropTypes.func,
    setTimeframe: PropTypes.func,
    // newImageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        inputData: state.smartWidget.inputData,
        // newImageId: state.smartWidget.newImageId,
        smartWidget: state.smartWidget,
        division: state.division,
        driver: state.driver,
        asset: state.asset,
        telematicsRetentionDays: state.user.userCompany.telematics_retention_days,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...dashboardActions,
            ...smartWidgetActions
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(PieChartForm);
